import React from 'react';
import { Menu, MenuProps, MenuItem, MenuItemProps } from '@mui/material';


export const ClosableMenuContext = React.createContext<MenuProps['onClose']>(() => undefined);


export type ClosableMenuItemProps = MenuItemProps<'li', { onClick?: () => void }>;
export const ClosableMenuItem = React.forwardRef<HTMLLIElement, ClosableMenuItemProps>(({ onClick, children, value: _value, ...props }, ref) => {
  const menuContext = React.useContext(ClosableMenuContext);

  const handleClick: React.MouseEventHandler<HTMLLIElement> = (e) => {
    menuContext?.(e, 'backdropClick');
    onClick?.();
  };

  return (
    <MenuItem {...props} ref={ref} onClick={handleClick}>
      {children}
    </MenuItem>
  );
});


export type ClosableMenuProps = MenuProps;
export const ClosableMenu: React.FC<ClosableMenuProps> = (props) => {
  return (
    <ClosableMenuContext.Provider value={props.onClose}>
      <Menu autoFocus={false} {...props} />
    </ClosableMenuContext.Provider>
  );
};
